import type { CommandGroupType } from "@layer/utils/lib/commands";
import { atom } from "jotai";
import { defaultCommands } from "@/lib/constants/commands";
import { commandPageAtom } from "@/modules/command-bar/atoms/states/command-page-state";

// Custom commands, where we can add more dynamic commands for profile, compliance
export const customCommands: Record<string, CommandGroupType[]> = {
	customers: [],
};

// Match the root by URL path, like /customers/, /compliance/, etc.
export const matchPathEntity = (path: string): { entityType?: string } => {
	const entityKeys = Object.keys(customCommands).join("|");
	const match = path.match(new RegExp(`^/(${entityKeys})/([\\w-]+)$`));
	return match ? { entityType: match[1] } : {};
};

// Update the commands, combining default commands & additional commands based on the path
export const setCommandStoreAtom = atom(null, (_, set, pathname: string) => {
	let commands = [...defaultCommands];
	const { entityType } = matchPathEntity(pathname);

	if (entityType && customCommands[entityType]) {
		const pageSpecificCommands = customCommands[entityType];

		commands = [
			...pageSpecificCommands.filter(
				(newCommand) =>
					!commands.some((command) => command.id === newCommand.id),
			),
			...commands,
		];
	}

	set(commandPageAtom, commands);
});
